/** Resolve semantic resource events locally; the backend never supplies an arbitrary URL. */
const ID = /^[A-Za-z0-9_.:-]{1,128}$/;
const validId = value => typeof value === 'string' && ID.test(value) && value !== '.' && value !== '..';

const PAGES = {
    instructions: 'agent',
    tool: 'tools',
    skill: 'skills',
    knowledge: 'contents',
    mcp_server: 'mcp-servers',
    settings: 'settings',
    memory: 'memory',
    llm: 'llm-settings',
    access_key: 'access-keys',
    channel: 'channels',
    playbook: 'playbooks',
    workflow: 'journey',
    codehook: 'functions',
    sub_agent: 'sub-agents',
};
const DETAIL_PAGES = { playbook: 'playbooks', workflow: 'journey', codehook: 'functions/save', sub_agent: 'sub-agents' };
const CHANNEL_PAGES = { web: 'web/settings', voice: 'voice', fb: 'fb', twilio: 'twilio', whatsapp: 'whatsapp', slack: 'slack' };

export function resourcePathFor(resource, appId) {
    if (!validId(appId) || !resource || resource.appId !== appId
        || !['created', 'updated'].includes(resource.action)
        || !Object.hasOwn(PAGES, resource.kind)) return null;
    const base = `/app/${encodeURIComponent(appId)}`;
    if (resource.kind === 'channel') {
        const channel = Object.hasOwn(CHANNEL_PAGES, resource.id) ? CHANNEL_PAGES[resource.id] : 'web/settings';
        return `${base}/channels/${channel}`;
    }
    if (Object.hasOwn(DETAIL_PAGES, resource.kind) && resource.id != null) {
        if (!validId(resource.id)) return null;
        return `${base}/${DETAIL_PAGES[resource.kind]}/${encodeURIComponent(resource.id)}`;
    }
    return `${base}/${PAGES[resource.kind]}`;
}
